









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapServer } from '../../../../src/api/installService';
@Component({
  name: 'EnterpriseType',
  components: {},
})
export default class EnterpriseType extends Vue {
  @Prop() private drawPoint: any;
  @Prop() private menu: any;
  private pageTemporaryStorage: any;
  private xaxis: any = [
    '外资企业',
    '内资企业',
    '重点企业',
  ];
  private mounted(): void {
      this.getData();
  }
  private getData(): void {
      const that = this;
      mapServer.getAnalysis({
          creditCodeOrName: '',
          startTime: '',
          endTime: '',
          enterpriseId: '',
          enterpriseType: '',
          freeTradeZone: '',
          industryClass: '',
          industryCode: '',
          isKeyEnterprises: '',
          nowPage: 1,
          pageSize: 5,
          source: '1',
      }).then((res: any) => {
          if (res.status === 200) {
              const da = res.data.data;
              const val: any = [];
              const name: any = [];
              da.forEach((item: any) => {
                  if (this.xaxis.indexOf(item.typeName) !== -1) {
                      name.push(item.typeName);
                      val.push(item.countNum);
                  }
              });
              that.drawPie({
                  name,
                  value: val,
              });
          }
      });
  }
  private drawPie(data: any): void {
    const articleEchart: any = Vue.prototype.$echarts.init(
        document.getElementById('teamBox'),
    );
    const option: any = {
        backgroundColor: 'transparent',
        tooltip: {
        show: true,
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
        },
        },
        grid: {
            top: '40px',
            right: '3%',
            left: '10%',
            bottom: '60px',
        },
        xAxis: [{
            type: 'category',
            data: data.name,
            axisLine: {
                lineStyle: {
                    color: 'rgba(255,255,255, .5)',
                },
            },
            axisLabel: {
                margin: 10,
                lineHeight: 18,
                color: '#e2e9ff',
                // formatter: (params: any) => {
                //     let newParamsName = ''; // 最终拼接成的字符串
                //     let paramsNameNumber = params.length; // 实际标签的个数
                //     let provideNumber = 5; // 每行能显示的字的个数
                //     let rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
                //     if (paramsNameNumber > provideNumber) {
                //         for (var p = 0; p < rowNumber; p++) {
                //             var tempStr = ''; // 表示每一次截取的字符串
                //             var start = p * provideNumber; // 开始截取的位置
                //             var end = start + provideNumber; // 结束截取的位置
                //             // 此处特殊处理最后一行的索引值
                //             if (p === rowNumber - 1) {
                //                 // 最后一次不换行
                //                 tempStr = params.substring(start, paramsNameNumber);
                //             } else {
                //                 // 每一次拼接字符串并换行
                //                 tempStr = params.substring(start, end) + '\n';
                //             }
                //             newParamsName += tempStr; // 最终拼成的字符串
                //         }
                //     } else {
                //         // 将旧标签的值赋给新标签
                //         newParamsName = params;
                //     }
                //     // 将最终的字符串返回
                //     return newParamsName;
                // },
            },
        }],
        yAxis: [{
            axisLabel: {
                formatter: '{value}',
                color: '#e2e9ff',
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(255,255,255, .5)',
                },
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: 'rgba(255,255,255,0.12)',
                },
            },
        }],
        series: [
            {
                type: 'bar',
                data: data.value,
                barWidth: '12px',
                itemStyle: {
                    normal: {
                        color: '#12badd',
                        barBorderRadius: [30, 30, 30, 30],
                        shadowColor: 'rgba(0,160,221,1)',
                        shadowBlur: 4,
                    },
                },
                label: {
                    normal: {
                        show: true,
                        lineHeight: 20,
                        width: 45,
                        height: 20,
                        backgroundColor: 'rgba(0,160,221,0.1)',
                        borderRadius: 100,
                        position: ['-8', '-30'],
                        distance: 1,
                        formatter: [
                            ' {d|●}',
                            ' {a|{c}}',
                            '{b|}',
                        ].join(''),
                        rich: {
                            d: {
                                color: '#3CDDCF',
                                align: 'left',
                            },
                            a: {
                                color: '#fff',
                                align: 'left',
                            },
                            b: {
                                width: 1,
                                height: 1,
                                borderWidth: 1,
                                borderColor: 'transparent',
                                align: 'left',
                            },
                        },
                    },
                },
            },
        ],
    };
    articleEchart.setOption(option);
  }
}
